// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ai-insights-wrapper {
    background: #fdfcf9;
    border: 1px solid #e0e0e0;
    padding: 1.5rem;
    border-radius: 0.75rem;
    margin-top: 2rem;
}

.ai-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.75rem;
}

.ai-title-group {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.ai-icon {
    color: #0284c7;
    font-size: 1.75rem;
}

.ai-badge {
    background-color: #e0f7f7;
    color: #006d77;
    padding: 0.35rem 0.8rem;
    border-radius: 999px;
    font-weight: 600;
    font-size: 0.75rem;
    display: flex;
    align-items: center;
    gap: 6px;
    position: relative;
}

.pulse {
    width: 10px;
    height: 10px;
    background: #06b6d4;
    border-radius: 50%;
    animation: pulseBlink 1.5s infinite;
}

@keyframes pulseBlink {
    0%, 100% {
        opacity: 0.2;
        transform: scale(0.9);
    }

    50% {
        opacity: 1;
        transform: scale(1.4);
    }
}

.ai-description {
    font-size: 0.925rem;
    color: #444;
    margin-bottom: 1rem;
}

.insight-filters {
    display: flex;
    gap: 0.75rem;
    margin-bottom: 1rem;
}

    .insight-filters button {
        border: 1px solid #ccc;
        padding: 6px 12px;
        background: #fff;
        border-radius: 20px;
        font-size: 0.85rem;
        cursor: pointer;
        transition: 0.3s ease;
        color:#000000;
    }

        .insight-filters button.active {
            background: #006d77;
            color: white;
            border-color: #006d77;
        }

.ai-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    gap: 1rem;
}

.ai-card {
    background: #ffffff;
    border: 1px solid #e5e7eb;
    padding: 1rem;
    border-radius: 0.5rem;
    position: relative;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.eta {
    color: #0284c7;
    font-weight: bold;
}

.alert-yellow {
    background: #fef9c3;
    color: #92400e;
    padding: 0.5rem;
    font-size: 0.8rem;
    margin-top: 0.5rem;
    border-radius: 0.4rem;
    display: flex;
    align-items: center;
    gap: 0.4rem;
}

.alert-red {
    background: #fee2e2;
    color: #991b1b;
    padding: 0.5rem;
    font-size: 0.8rem;
    margin-top: 0.5rem;
    border-radius: 0.4rem;
    display: flex;
    align-items: center;
    gap: 0.4rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/AIInsights.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,uBAAuB;IACvB,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,mCAAmC;AACvC;;AAEA;IACI;QACI,YAAY;QACZ,qBAAqB;IACzB;;IAEA;QACI,UAAU;QACV,qBAAqB;IACzB;AACJ;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;AACvB;;IAEI;QACI,sBAAsB;QACtB,iBAAiB;QACjB,gBAAgB;QAChB,mBAAmB;QACnB,kBAAkB;QAClB,eAAe;QACf,qBAAqB;QACrB,aAAa;IACjB;;QAEI;YACI,mBAAmB;YACnB,YAAY;YACZ,qBAAqB;QACzB;;AAER;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,qBAAqB;IACrB,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf","sourcesContent":[".ai-insights-wrapper {\n    background: #fdfcf9;\n    border: 1px solid #e0e0e0;\n    padding: 1.5rem;\n    border-radius: 0.75rem;\n    margin-top: 2rem;\n}\n\n.ai-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 0.75rem;\n}\n\n.ai-title-group {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n}\n\n.ai-icon {\n    color: #0284c7;\n    font-size: 1.75rem;\n}\n\n.ai-badge {\n    background-color: #e0f7f7;\n    color: #006d77;\n    padding: 0.35rem 0.8rem;\n    border-radius: 999px;\n    font-weight: 600;\n    font-size: 0.75rem;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    position: relative;\n}\n\n.pulse {\n    width: 10px;\n    height: 10px;\n    background: #06b6d4;\n    border-radius: 50%;\n    animation: pulseBlink 1.5s infinite;\n}\n\n@keyframes pulseBlink {\n    0%, 100% {\n        opacity: 0.2;\n        transform: scale(0.9);\n    }\n\n    50% {\n        opacity: 1;\n        transform: scale(1.4);\n    }\n}\n\n.ai-description {\n    font-size: 0.925rem;\n    color: #444;\n    margin-bottom: 1rem;\n}\n\n.insight-filters {\n    display: flex;\n    gap: 0.75rem;\n    margin-bottom: 1rem;\n}\n\n    .insight-filters button {\n        border: 1px solid #ccc;\n        padding: 6px 12px;\n        background: #fff;\n        border-radius: 20px;\n        font-size: 0.85rem;\n        cursor: pointer;\n        transition: 0.3s ease;\n        color:#000000;\n    }\n\n        .insight-filters button.active {\n            background: #006d77;\n            color: white;\n            border-color: #006d77;\n        }\n\n.ai-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n    gap: 1rem;\n}\n\n.ai-card {\n    background: #ffffff;\n    border: 1px solid #e5e7eb;\n    padding: 1rem;\n    border-radius: 0.5rem;\n    position: relative;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.eta {\n    color: #0284c7;\n    font-weight: bold;\n}\n\n.alert-yellow {\n    background: #fef9c3;\n    color: #92400e;\n    padding: 0.5rem;\n    font-size: 0.8rem;\n    margin-top: 0.5rem;\n    border-radius: 0.4rem;\n    display: flex;\n    align-items: center;\n    gap: 0.4rem;\n}\n\n.alert-red {\n    background: #fee2e2;\n    color: #991b1b;\n    padding: 0.5rem;\n    font-size: 0.8rem;\n    margin-top: 0.5rem;\n    border-radius: 0.4rem;\n    display: flex;\n    align-items: center;\n    gap: 0.4rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
